import { RouteObject } from 'react-router-dom';

import i18n from 'app/i18n';
import { ModuleLayout } from 'app/layouts';

import Dashboard from './dashboard';

export const routes: RouteObject[] = [
  { path: '', element: <ModuleLayout />,
    handle: { title: i18n.t('dashboard.title') },
    children: [
      { path: '', index: true, element: <Dashboard />,
        handle: { exclude: true },
      },
    ],
  },
];
